import { useMemo } from "react";
import { ListWorkOrderTemplateDto } from "../models/workordertemplate.models";
import { useSearch } from "./SearchBox.hook";

export function useFilteredWorkOrderTemplates(templates: ListWorkOrderTemplateDto[]) {
	const { query } = useSearch();

	const filteredTemplates = useMemo(() => {
		if (query && query.length > 0) {
			const lowerQuery = query.toLowerCase();
			return templates?.filter(template =>
				(template.Title && template.Title.toLowerCase().includes(lowerQuery))
			) || [];
		}

		return templates || [];
	}, [query, templates]);

	return { filteredTemplates, showNoResults: query && query.length > 0 && filteredTemplates.length === 0 };
}
